export default "__VITE_ASSET__BX_0Gec0__"